import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Layout, Card, TextStyle, AppProvider, Page, DescriptionList, Badge, List, PageActions, Link, Toast, Frame } from '@shopify/polaris';
import { EditMajorMonotone, ViewMajorMonotone } from '@shopify/polaris-icons';
import { ta } from 'utils';
import { statusSlugs } from 'utils/recordHelpers';

import UpdateModalForm from './components/UpdateModalForm';

import axios from 'utils/axios';

const propTypes = {
  record: PropTypes.object.isRequired,
  submitURL: PropTypes.string.isRequired,
  nextStatus: PropTypes.string,

  rejectURL: PropTypes.string.isRequired,
  approveURL: PropTypes.string.isRequired,
  userURL: PropTypes.string,
}

const defaultProps = {
  // nextStatus: null,
}

const SellerApplicationFormShow = (props) => {
  const [toastMessage, setToastMessage] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [sellerForm, setSellerForm] = useState(props.record)
  const [nextStatus, setNextStatus] = useState(props.nextStatus);

  console.log("P", props);

  const dismissToast = () => setToastMessage(null);

  const openEditModal = () => {
    setOpenModal(true);
  }

  const closeModal = () => setOpenModal(false);

  const handleSubmit = async (values, formikBag) => {
    console.log("V", values);
    try {
      const response = await axios.put(props.submitURL, values);
      setToastMessage(I18n.t("app.messages.save_success"));
      setSellerForm(values);
      closeModal();
    } catch (error) {
      console.warn("E", error);
      const errors = error.response && error.response.data; 
      if(errors){
        setToastMessage(I18n.t("app.messages.record_errors"));
        console.log("Errors", errors)
        formikBag.setErrors(errors);
      }
    } // end catch
  }

  const handleApprove = async (newStatus) => {
    const confirmPrompt = newStatus == "approved" ? "Esta acción creará el usuario en Seller y en BrightPearl. También se enviará un email al Seller para definir su contraseña. ¿Desea continuar?" : "¿Confirmar acción?"
    try {
      if (confirm(confirmPrompt)) {
        const response = await axios.put(props.approveURL, { new_status: newStatus });
        const { data } = response;
        setToastMessage(I18n.t("app.messages.save_success"));
        setSellerForm({
          ...sellerForm,
          status: data.status,
        });
        setNextStatus(data.next_status);
      }
    } catch (error) {
      console.warn("E", error);
      const message = error.response && error.response.data
      if(message){
        setToastMessage(message);
      }
    }
  } // end catch

  const handleReject = async () => {
    try {
      if (confirm('Esta acción es irreversible, continuar?')) {
        const response = await axios.put(props.rejectURL);
        setToastMessage(I18n.t("app.messages.save_success"));
        setSellerForm({
          ...sellerForm,
          status: "rejected",
        });
        setNextStatus(null);
      }
    } catch (error) {
      console.warn("E", error);
      const message = error.response && error.response.data
      if(message){
        setToastMessage(message);
      }
    }
  } // end catch

  // UI stuff
  const salespointsItem = () => {
    return(
      <List type="bullet">
        { sellerForm.salespoints.map( name =>  
          <List.Item key={ name }>{ I18n.t(`app.salespoints.${name}`) }</List.Item>
        )}
        { !!sellerForm.salespoints_other &&
           <List.Item>{ sellerForm.salespoints_other }</List.Item>
        }
      </List>
    )
  }

  const contactItems = [
    { term: ta("general.name"), description: `${sellerForm.first_name} ${sellerForm.last_name}` },
    { term: ta("general.email"), description: sellerForm.email },
    { term: ta("general.phone"), description: sellerForm.phone },
  ];

  const companyItems = [
    { term: ta("seller_application_form.company_name"), description: sellerForm.company_name },
    { term: ta("seller_application_form.legal_id"), description: sellerForm.legal_id },
    { term: ta("seller_application_form.bank_account_number"), description: sellerForm.bank_account_number },
    { term: ta("general.address"), description: sellerForm.address },
  ];
  
  const commerceItems = [
    { term: ta("seller_application_form.commerce_information"), description: sellerForm.commerce_information },
    { term: ta("seller_application_form.website"), description: sellerForm.website },
    { term: "Puntos de venta:", description: salespointsItem() },
    { term: ta("general.currency"), description: I18n.t(`enum.currency.${sellerForm.currency}`) },
    { term: ta("seller_application_form.catalog"), description: sellerForm.catalog && sellerForm.catalog.url && <Link external url={ sellerForm.catalog.url }>Descargar</Link> },
  ];

  let pageActions = [];
  const handleMainApprove = () => handleApprove(nextStatus);
  
  if(sellerForm.status != "rejected" && !!nextStatus){
    pageActions = [...pageActions, { content: 'Rechazar', destructive: true, onAction: handleReject } ]
  }
  if( sellerForm.status == "pre_approved" ){
    pageActions = [...pageActions, { content: `Marcar como ${I18n.t(`enum.status.on_hold`)}`, onAction: () => handleApprove("on_hold"), outline: true } ]
  }

  let pageSecondaryActions = [];
  if( ["pending", "pre_approved", "on_hold"].includes(sellerForm.status) ){
    pageSecondaryActions = [ ...pageSecondaryActions, { icon: EditMajorMonotone, onAction: openEditModal, content: "Editar" } ];
  }
  if( !!props.userURL ){
    pageSecondaryActions = [ ...pageSecondaryActions, { icon: ViewMajorMonotone, content: "Ver Usuario", url: props.userURL, external: true } ];
  }
  // if( ["pending", "pre_approved", "on_hold"].includes(sellerForm.status) ){
  //   pageActions = [...pageActions, { content: 'Editar', onAction: openEditModal } ]
  // }

  return (
    <AppProvider>
      <Frame>
        <Page
          title={`${I18n.t("activerecord.models.seller_application_form.one")} #${sellerForm.id}`} fullWidth
          titleMetadata={ <Badge status={ statusSlugs[sellerForm.status] }>{ I18n.t(`enum.status.${sellerForm.status}`) }</Badge> }
          breadcrumbs= {[{content: I18n.t("actions.back"), url: '/seller_application_forms'}]}
          secondaryActions={ pageSecondaryActions }
          subtitle={ I18n.l("time.formats.long", sellerForm.created_at) }
        >
          <Layout>
            <Layout.Section oneHalf>
              <Card>
                <Card.Section title={I18n.t("app.seller_application_form.sections.contact")}>
                  <DescriptionList items={ contactItems }/>
                </Card.Section>
              </Card>
              <Card>
                <Card.Section title={I18n.t("app.seller_application_form.sections.company")}>
                  <DescriptionList items={ companyItems }/>
                </Card.Section>
              </Card>
            </Layout.Section>
            <Layout.Section oneHalf>
              <Card>
                <Card.Section title={I18n.t("app.seller_application_form.sections.commerce")}>
                  <DescriptionList items={ commerceItems }/>
                </Card.Section>
              </Card>
            </Layout.Section>
          </Layout>
          <PageActions
            primaryAction={ !!nextStatus ? { content: `Marcar como ${I18n.t(`enum.status.${nextStatus}`)}`, onAction: handleMainApprove } : null }
            secondaryActions={ pageActions }
          />
          <UpdateModalForm
            title="Actualizar"
            record={ sellerForm }
            open={ openModal }
            currencies={ props.currencies }
            onClose={ closeModal }
            onSubmit={ handleSubmit }
          />
          { !!toastMessage &&
            <Toast
              content={ toastMessage }
              onDismiss={ dismissToast }
            />
          }
        </Page>
      </Frame>
    </AppProvider>
  )
};

SellerApplicationFormShow.propTypes = propTypes;
SellerApplicationFormShow.defaultProps = defaultProps;

export default SellerApplicationFormShow;